$(document).ready(function(){
  let view_type = $.cookie('view_type');
  if(view_type == "ProductgridView"){
    $("#"+view_type).addClass("active");
    $("#ProductgridView").addClass( "active");
    $("#ProductListView").removeClass( "active");
    $("#product-grid").removeClass( "list_view");
  } else if (view_type == "ProductListView"){
    $("#"+view_type).addClass("active");
    $("#ProductgridView").removeClass( "active");
    $("#ProductListView").addClass( "active");
    $("#product-grid").addClass( "list_view");
  } else {
    $("#ProductgridView").addClass("active");
    $("#ProductgridView").addClass( "active");
    $("#ProductListView").removeClass( "active");
  }
  $("#ProductgridView").click(function(){
      $("#ProductgridView").addClass( "active");
      $("#ProductListView").removeClass( "active");
      $("#product-grid").removeClass( "list_view");
      $.cookie('view_type', "ProductgridView");
  });
  $("#ProductListView").click(function(){
    $("#ProductgridView").removeClass( "active");
    $("#ProductListView").addClass( "active");
    $("#product-grid").addClass( "list_view");
    $.cookie('view_type', "ProductListView");
  });
  $(".tab_item").first().addClass("active");  
  $(".tab_item").click(function(){
  var dIn = $(this).attr("data-dindex");
    $(".tab_item").removeClass("active");
    $(this).addClass("active");
    $(".plan_section").addClass("visually-hidden");
    $(".plan_section_"+dIn).removeClass("visually-hidden");
    console.log(dIn);
    
});
    
  $(".condition_text").on("click", function(){

    $(this).next(".popup_content").toggle("slow");
});
});